import React from "react";
import { SectionTitle } from "components/items";
import makeTitle from "function/makeTitle.js";

import productCategory_01 from "image/product/category/productCategory-01.png";
import productCategory_02 from "image/product/category/productCategory-02.png";
import productCategory_03 from "image/product/category/productCategory-03.png";
import productCategory_04 from "image/product/category/productCategory-04.png";
import productCategory_05 from "image/product/category/productCategory-05.png";
import productCategory_06 from "image/product/category/productCategory-06.png";
import productCategory_07 from "image/product/category/productCategory-07.png";
import productCategory_08 from "image/product/category/productCategory-08.png";
import productCategory_09 from "image/product/category/productCategory-09.png";
import productCategory_10 from "image/product/category/productCategory-10.png";

const sectionTitle = [
	{
		text: "OUR",
		color: "defualt",
		break: false,
	},
	{
		text: "PRODUCT",
		color: "main",
		break: true,
	},
];

const categoryList = [
	{
		id: 1,
		image: productCategory_01,
		title: "CP비누",
	},
	{
		id: 2,
		image: productCategory_02,
		title: "입욕제",
	},
	{
		id: 3,
		image: productCategory_03,
		title: "설거지바",
	},
	{
		id: 4,
		image: productCategory_04,
		title: "약산성비누",
	},
	{
		id: 5,
		image: productCategory_05,
		title: "샴푸바",
	},
	{
		id: 6,
		image: productCategory_06,
		title: "린스바",
	},
	{
		id: 7,
		image: productCategory_07,
		title: "가루입욕제",
	},
	{
		id: 8,
		image: productCategory_08,
		title: "MP비누",
	},
	{
		id: 9,
		image: productCategory_09,
		title: "D.I.Y 키트",
	},
	{
		id: 10,
		image: productCategory_10,
		title: "반려동물 비누",
	},
];

const OurProducts = () => {
	return (
		<section className="OurProducts">
			<div className="section-header">
				<div className="con">
					<SectionTitle text={makeTitle(sectionTitle)} type="center" />
					<p className="section-text center">
						동구밭에서 생산하고 있는 제품 카테고리입니다. <br />이 밖에도 다른 고체 제품 생산을 원하시면 고객상담실로 연락주세요
					</p>
				</div>
			</div>
			<div className="section-contents">
				<div className="con">
					<ul className="wrap-category">
						{categoryList.map((el) => {
							const style = {
								backgroundImage: `url(${el.image})`,
							};
							return (
								<li className="category" key={el.id} style={style}>
									<p>{el.title}</p>
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		</section>
	);
};

export default OurProducts;
